// @ts-nocheck


import React from 'react';



import Contracts from './Contracts/Form';
import CostEstimation from './CostEstimation/Form';










export default (props) => {
  const { id, orgUnitId, branchBudgetSummary, budgetSummary, onSubmit } = props;

  const getComponents = () => {
    switch (props.type) {
      case 'contracts':
        return (
          <Contracts
            id={id}
            orgUnitId={orgUnitId}
            budgetSummary={budgetSummary}
            branchBudgetSummary={branchBudgetSummary} />);


      default:
        return (
          <CostEstimation
            id={id}
            orgUnitId={orgUnitId}
            budgetSummary={budgetSummary}
            branchBudgetSummary={branchBudgetSummary}
            onSubmit={onSubmit} />);


    }
  };

  return getComponents();
};
